customElements.define('support-search', class extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.form = this.querySelector('.support-search-form');
        this.resultsContainer = this.querySelector('.search-results');
        this.resultsInner = this.querySelector('.search-results-inner');
        this.closeButton = this.querySelector('.close-button');
        this.closeButton.addEventListener('click', this.handleCloseButtonClick.bind(this));
        // 从组件属性读取搜索字段名，默认为 'q'
        this.searchFieldName = this.getAttribute('data-search-field') || 'q';
        this.searchField = this.querySelector(`input[name="${this.searchFieldName}"]`);
        this.resultsContainer.classList.add('tw-opacity-0', 'tw-scale-95', 'tw-transition', 'tw-duration-300', 'tw-ease-in-out');
        //监听表单input框改变事件
        this.form.addEventListener('input', window._debounce(this.handleInput.bind(this), 500));
        // 阻止表单默认提交行为（防止按 enter 键时页面跳转）
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
        // 使用事件委托处理动态生成的结果项点击
        this.resultsInner.addEventListener('click', this.handleResultClick.bind(this));
        // 点击页面其他地方时隐藏结果框
        document.addEventListener('click', this.handleDocumentClick.bind(this));
    }
    handleSubmit(event) {
        // 阻止表单默认提交行为，防止页面跳转
        event.preventDefault();
    }
    handleCloseButtonClick(event) {
        event.preventDefault();
        this.searchField.value = '';
        this.hideResults();
    }
    handleDocumentClick(event) {
        // 检查点击是否在组件内部
        if (this.contains(event.target)) {
            return; // 点击在组件内，不隐藏
        }
        this.searchField.value = '';
        // 点击在组件外，隐藏结果框
        this.hideResults();
    }
    handleResultClick(event) {
        // 找到最近的搜索结果项元素
        const resultItem = event.target.closest('.search-result-item');
        if (!resultItem) return;
        // console.log('点击了搜索结果项:', resultItem);
        this.searchField.value = resultItem.textContent.trim();
        this.hideResults();
    }
    handleInput(event) {
        event.preventDefault();
        const formData = new FormData(this.form);
        const query = formData.get(this.searchFieldName)?.trim() || '';
        
        // 如果查询为空，隐藏结果框
        if (query.length < 1) {
            this.hideResults();
            return;
        }
        
        const params = new URLSearchParams(formData);
        const searchUrl = `${this.form.action}?${params.toString()}`;
        this.resultsContainer.classList.add("search-loading");
        if (this.resultsContainer.classList.contains('tw-hidden')) {
            this.resultsContainer.classList.remove('tw-hidden');
        }
        requestAnimationFrame(() => {
            if (this.resultsContainer.classList.contains('tw-opacity-0')) {
                this.resultsContainer.classList.remove('tw-opacity-0');
                this.resultsContainer.classList.add('tw-opacity-100');
            }
        });
        fetch(searchUrl)
            .then(response => response.text())
            .then(html => {
                this.updateResults(html);
            })
            .catch(error => {
                console.error('Error fetching search results:', error);
            }).finally(() => {
                this.resultsContainer.classList.remove("search-loading");
            });
    }
    hideResults() {
        // 隐藏结果框的动画
        requestAnimationFrame(() => {
            this.resultsContainer.classList.add('tw-opacity-0');
            this.resultsContainer.classList.add('tw-scale-95');
        });
        // 延迟后隐藏容器
        setTimeout(() => {
            this.resultsContainer.classList.add('tw-hidden');
        }, 300);
    }
    updateResults(html) {
        const resultsInner = this.querySelector('.search-results-inner');
        resultsInner.innerHTML = html;
    }
});

// Tab组件相关的自定义元素定义
//   const tabComponents = {
//     // Tab列表容器
//     'tab-list': class extends HTMLElement {
//       static get observedAttributes() {
//         return ['mode'];
//       }

//       constructor() {
//         super();
//         this._scrollable = false;
//         this.swiperInstance = null;
//       }

//       connectedCallback() {
//         // 初始化可滚动容器
//         this.initScrollContainer();

//         // 初始化模式
//         this._updateMode(this.getAttribute('mode'));

//         // 监听resize事件以更新滚动状态
//         window.addEventListener('resize', this.checkOverflow.bind(this));

//         // 设置WAI-ARIA属性
//         this.setAttribute('role', 'tablist');

//         // 在初始化时更新活动tab的指示器
//         requestAnimationFrame(() => {
//           const activeTab = this.querySelector('tab-item[active]');
//           if (activeTab) {
//             activeTab.updateIndicator();
//           }
//         });
//       }

//       disconnectedCallback() {
//         // 清理Swiper实例
//         if (this.swiperInstance && this.swiperInstance.destroy) {
//           this.swiperInstance.destroy(true, true);
//           this.swiperInstance = null;
//         }
//       }

//       // 初始化滚动容器
//       initScrollContainer() {
//         if (this.initialized) return;

//         // 直接在tab-list元素上设置滚动属性
//         this.classList.add('tabs-scroll-wrapper');

//         // 初始化Swiper
//         this.initSwiper();

//         // 检查是否需要滚动
//         this.checkOverflow();

//         this.initialized = true;
//       }

//       // 初始化Swiper
//       initSwiper() {
//         // 将现有的tab-item包装成Swiper结构
//         this.wrapWithSwiper();

//         // 延迟初始化Swiper以确保DOM结构已更新
//         setTimeout(() => {
//           const swiperContainer = this.querySelector('.swiper');
//           if (swiperContainer && typeof Swiper !== 'undefined') {
//             this.swiperInstance = new Swiper(swiperContainer, {
//               slidesPerView: 'auto',
//               spaceBetween: 40,
//               freeMode: true,
//               mousewheel: {
//                 forceToAxis: true,
//                 sensitivity: 1,
//                 releaseOnEdges: true,
//               },
//               resistance: true,
//               resistanceRatio: 0.85,
//               watchOverflow: true,
//               grabCursor: true,
//               preventClicks: false,
//               preventClicksPropagation: false,
//               normalizeSlideIndex: false,
//               centerInsufficientSlides: false,
//             });

//             // 监听滑动事件，同步指示器位置
//             this.swiperInstance.on('touchMove', () => {
//               this.updateIndicatorForSwiper();
//             });

//             this.swiperInstance.on('transitionEnd', () => {
//               this.updateIndicatorForSwiper();
//             });

//             this.swiperInstance.on('scroll', () => {
//               this.updateIndicatorForSwiper();
//             });
//           }
//         }, 100);
//       }

//       // 将tab-item包装成Swiper结构
//       wrapWithSwiper() {
//         const tabItems = Array.from(this.children);

//         if (tabItems.length === 0) return;

//         // 创建Swiper容器结构
//         const swiperContainer = document.createElement('div');
//         swiperContainer.className = 'swiper';

//         const swiperWrapper = document.createElement('div');
//         swiperWrapper.className = 'swiper-wrapper';

//         // 将每个tab-item包装成swiper-slide
//         tabItems.forEach(tabItem => {
//           if (tabItem.tagName === 'TAB-ITEM') {
//             const swiperSlide = document.createElement('div');
//             swiperSlide.className = 'swiper-slide';

//             // 将tab-item移动到slide中
//             swiperSlide.appendChild(tabItem.cloneNode(true));
//             swiperWrapper.appendChild(swiperSlide);
//           } else {
//             // 保留非tab-item元素（如文本节点）
//             swiperWrapper.appendChild(tabItem.cloneNode(true));
//           }
//         });

//         swiperContainer.appendChild(swiperWrapper);

//         // 清空原内容并添加Swiper结构
//         this.innerHTML = '';
//         this.appendChild(swiperContainer);

//         // 重新绑定tab-item的事件
//         this.rebindTabItemEvents();
//       }

//       // 重新绑定tab-item事件
//       rebindTabItemEvents() {
//         const tabItems = this.querySelectorAll('tab-item');
//         tabItems.forEach(tabItem => {
//           // 如果tab-item已经连接到DOM，重新触发connectedCallback
//           if (tabItem.connectedCallback) {
//             tabItem.connectedCallback();
//           }
//         });
//       }

//       // 为Swiper更新指示器位置
//       updateIndicatorForSwiper() {
//         const activeTab = this.querySelector('tab-item[active]');
//         if (!activeTab || !this.swiperInstance) return;

//         const slide = activeTab.closest('.swiper-slide');
//         const slideRect = slide.getBoundingClientRect();
//         const containerRect = this.swiperInstance.el.getBoundingClientRect();

//         const left = slideRect.left - containerRect.left + this.swiperInstance.translate;
//         const width = slideRect.width;
//         const level = this.getAttribute('level') === 'two' ? 'two' : 'one';

//         this.style.setProperty(`--tab-level-${level}-left`, `${left}px`);
//         this.style.setProperty(`--tab-level-${level}-width`, `${width}px`);
//       }

//       // 检查是否需要显示滚动功能
//       checkOverflow() {
//         const swiperContainer = this.querySelector('.swiper');
//         if (swiperContainer) {
//           // 使用Swiper的宽度检查
//           const swiperWrapper = this.querySelector('.swiper-wrapper');
//           const needsScroll = swiperWrapper.scrollWidth > swiperContainer.clientWidth;
//           if (needsScroll !== this._scrollable) {
//             this._scrollable = needsScroll;
//             this.classList.toggle('is-scrollable', needsScroll);
//           }
//         } else {
//           // 降级到原生滚动检查
//           const needsScroll = this.scrollWidth > this.clientWidth;
//           if (needsScroll !== this._scrollable) {
//             this._scrollable = needsScroll;
//             this.classList.toggle('is-scrollable', needsScroll);
//           }
//         }
//       }

//       // 将特定tab滚动到可视区域
//       scrollTabIntoView(tabElement) {
//         if (!tabElement) return;

//         if (this.swiperInstance) {
//           // 使用Swiper滑动到指定tab
//           const slide = tabElement.closest('.swiper-slide');
//           if (slide) {
//             const slides = Array.from(this.querySelectorAll('.swiper-slide'));
//             const slideIndex = slides.indexOf(slide);
//             if (slideIndex !== -1) {
//               this.swiperInstance.slideTo(slideIndex, 300);
//             }
//           }
//         } else {
//           // 降级到原生滚动
//           const tabRect = tabElement.getBoundingClientRect();
//           const listRect = this.getBoundingClientRect();

//           if (tabRect.left < listRect.left || tabRect.right > listRect.right) {
//             const targetScroll =
//               tabElement.offsetLeft -
//               (this.clientWidth - tabElement.offsetWidth) / 2;

//             this.scrollTo({
//               left: targetScroll,
//               behavior: 'smooth'
//             });
//           }
//         }
//       }

//       attributeChangedCallback(name, oldValue, newValue) {
//         if (name === 'mode' && oldValue !== newValue) {
//           this._updateMode(newValue);
//         }
//       }

//       _updateMode(mode) {
//         // 移除旧的模式类
//         this.classList.remove('mode-left', 'mode-center');
//         // 添加新的模式类
//         if (mode === 'center' || mode === 'left') {
//           this.classList.add(`mode-${mode}`);
//         } else {
//           // 默认为左对齐
//           this.classList.add('mode-left');
//         }
//       }
//     },

//     // Tab项
//     'tab-item': class extends HTMLElement {
//       static get observedAttributes() {
//         return ['active'];
//       }

//       constructor() {
//         super();
//         this._active = false;
//       }

//       connectedCallback() {
//         // 设置默认属性
//         if (!this.hasAttribute('role')) {
//           this.setAttribute('role', 'tab');
//         }
//         if (!this.hasAttribute('tabindex')) {
//           this.setAttribute('tabindex', '0');
//         }

//         // 添加事件监听
//         this.addEventListener('click', this._onClick.bind(this));
//         this.addEventListener('keydown', this._onKeydown.bind(this));
//       }

//       attributeChangedCallback(name, oldValue, newValue) {
//         if (name === 'active') {
//           this._active = this.hasAttribute('active');
//           this.setAttribute('aria-selected', this._active.toString());
//           this.setAttribute('tabindex', this._active ? '0' : '-1');
          
//           // 更新指示器
//           if (this._active) {
//             this.updateIndicator();
//             // 确保可见
//             this.closest('tab-list')?.scrollTabIntoView(this);
//           }
//         }
//       }

//       // 更新指示器位置
//       updateIndicator() {
//         const list = this.closest('tab-list');
//         if (!list) return;

//         const level = list.getAttribute('level') === 'two' ? 'two' : 'one';

//         // 如果list有Swiper实例，使用Swiper的位置计算
//         if (list.swiperInstance && list.updateIndicatorForSwiper) {
//           list.updateIndicatorForSwiper();
//           return;
//         }

//         // 降级到原生计算
//         const tabRect = this.getBoundingClientRect();
//         const listRect = list.getBoundingClientRect();

//         // 计算相对于 tab-list 的位置
//         const adjustedLeft = tabRect.left - listRect.left + list.scrollLeft;

//         // 设置指示器位置和宽度
//         list.style.setProperty(`--tab-level-${level}-left`, `${adjustedLeft}px`);
//         list.style.setProperty(`--tab-level-${level}-width`, `${tabRect.width}px`);
//       }

//       _onClick() {
//         this.select();
//       }

//       _onKeydown(event) {
//         switch (event.key) {
//           case 'Enter':
//           case ' ':
//             event.preventDefault();
//             this.select();
//             break;
//           case 'ArrowLeft':
//             event.preventDefault();
//             this.selectPrevious();
//             break;
//           case 'ArrowRight':
//             event.preventDefault();
//             this.selectNext();
//             break;
//         }
//       }

//       // 选中此tab
//       select() {
//         if (this._active) return;

//         const list = this.closest('tab-list');
//         const allTabs = Array.from(list.querySelectorAll('tab-item'));
        
//         // 取消其他tab的选中状态
//         allTabs.forEach(tab => {
//           if (tab !== this) {
//             tab.removeAttribute('active');
//           }
//         });

//         // 选中当前tab
//         this.setAttribute('active', '');
        
//         // 触发选中事件
//         this.dispatchEvent(new CustomEvent('tab:select', {
//           bubbles: true,
//           detail: {
//             tabId: this.dataset.tabId,
//             parentList: list.getAttribute('level') === 'two' 
//               ? list.dataset.parent 
//               : null
//           }
//         }));
//       }

//       // 选择上一个tab
//       selectPrevious() {
//         const list = this.closest('tab-list');
//         const allTabs = Array.from(list.querySelectorAll('tab-item'));
//         const index = allTabs.indexOf(this);
//         const previous = allTabs[index - 1] || allTabs[allTabs.length - 1];
//         previous.select();
//       }

//       // 选择下一个tab
//       selectNext() {
//         const list = this.closest('tab-list');
//         const allTabs = Array.from(list.querySelectorAll('tab-item'));
//         const index = allTabs.indexOf(this);
//         const next = allTabs[index + 1] || allTabs[0];
//         next.select();
//       }
//     },

//     // Tab面板
//     'tab-panel': class extends HTMLElement {
//       constructor() {
//         super();
//       }

//       connectedCallback() {
//         if (!this.hasAttribute('role')) {
//           this.setAttribute('role', 'tabpanel');
//         }
//       }
//     }
//   };

//   // 注册所有tab相关组件
//   Object.entries(tabComponents).forEach(([tagName, componentClass]) => {
//     if (!customElements.get(tagName)) {
//       customElements.define(tagName, componentClass);
//     }
//   });

//   // 主Tab组件 - 简化版本，主要负责样式管理和面板切换
//   customElements.define('global-tab', class GlobalTab extends HTMLElement {
//     constructor() {
//       super();
//       this.initStyles();
//     }

//     connectedCallback() {
//       // 监听tab选择事件
//       this.addEventListener('tab:select', this._onTabSelect.bind(this));
//     }

//     // 初始化样式
//     initStyles() {
//       if (!document.getElementById('global-tab-styles')) {
//         const style = document.createElement('style');
//         style.id = 'global-tab-styles';
//         style.textContent = this.getStyles();
//         document.head.appendChild(style);
//       }
//     }

//     // 处理tab选择事件
//     _onTabSelect(event) {
//       const { tabId, parentList } = event.detail;

//       if (!parentList) {
//         // 一级tab被选中
//         this._handleLevelOneSelect(tabId);
//       } else {
//         // 二级tab被选中
//         this._handleLevelTwoSelect(tabId);
//       }
//     }

//     // 处理一级tab选择
//     _handleLevelOneSelect(tabId) {
//       // 更新二级tab列表显示状态
//       const allLevelTwo = this.querySelectorAll('tab-list[level="two"]');
//       allLevelTwo.forEach(list => {
//         const shouldShow = list.dataset.parent === tabId;
//         list.hidden = !shouldShow;

//         // 如果显示新的二级列表，选中其第一个tab
//         if (shouldShow) {
//           const firstTab = list.querySelector('tab-item');
//           if (firstTab) {
//             // 移除所有激活状态
//             list.querySelectorAll('tab-item[active]').forEach(tab => {
//               tab.removeAttribute('active');
//             });

//             // 等待DOM更新后再处理
//             requestAnimationFrame(() => {
//               firstTab.setAttribute('active', '');
//               firstTab.updateIndicator();
//               this._showPanel(firstTab?.dataset.tabId);
//             });
//           }
//         }
//       });

//       // 如果没有二级tab，直接显示对应面板
//       if (!this.querySelector(`tab-list[data-parent="${tabId}"]`)) {
//         this._showPanel(tabId);
//       }
//     }

//     // 处理二级tab选择
//     _handleLevelTwoSelect(tabId) {
//       this._showPanel(tabId);
//     }

//     // 显示指定的面板
//     _showPanel(tabId) {
//       const allPanels = this.querySelectorAll('tab-panel');
//       allPanels.forEach(panel => {
//         panel.hidden = panel.dataset.tabId !== tabId;
//       });
//     }

//     // 获取组件样式
//     getStyles() {
//       return `
//         global-tab {
//           display: block;
//           width: 100%;
//         }

//         .tabs-scroll-wrapper {
//           overflow: hidden;
//           position: relative;
//           border-bottom: 1px solid #0D0D101F;
//         }

//         /* Swiper 样式 */
//         .swiper {
//           width: 100%;
//           height: auto;
//         }

//         .swiper-wrapper {
//           display: flex;
//           align-items: center;
//         }

//         .swiper-slide {
//           width: auto !important;
//           flex-shrink: 0;
//         }

//         /* 隐藏Swiper导航，只保留滚动功能 */
//         .swiper-button-next,
//         .swiper-button-prev {
//           display: none !important;
//         }

//         /* Swiper分页器样式 */
//         .swiper-pagination {
//           display: none;
//         }

//         tab-list {
//           display: block;
//           position: relative;
//           width: 100%;
//         }

//         @media (min-width: 768px) {
//           tab-list.mode-center .swiper-wrapper {
//             justify-content: center;
//           }
//         }

//         tab-item {
//           padding: 15px 0;
//           margin-right: 64px;
//           color: #0d0d1066;
//           cursor: pointer;
//           white-space: nowrap;
//           transition: color 0.3s;
//           display: inline-block;
//           user-select: none;
//         }

//         tab-item:last-child {
//           margin-right: 0;
//         }

//         tab-item:hover {
//           color: #0d0d1080;
//         }

//         tab-item[active] {
//           color: #0d0d10;
//         }

//         /* 指示器样式 */
//         tab-list::after {
//           content: '';
//           position: absolute;
//           bottom: 0;
//           height: 1px;
//           background: #0d0d10;
//           transition: all 0.3s ease;
//           pointer-events: none;
//         }

//         tab-list[level="one"]::after {
//           left: 0;
//           width: var(--tab-level-one-width, 0);
//           transform: translateX(var(--tab-level-one-left, 0));
//         }

//         tab-list[level="two"]::after {
//           left: 0;
//           width: var(--tab-level-two-width, 0);
//           transform: translateX(var(--tab-level-two-left, 0));
//         }

//         tab-panels {
//           display: block;
//           margin-top: 20px;
//         }

//         /* 移动端优化 */
//         @media (max-width: 768px) {
//           tab-item {
//             margin-right: 40px;
//             font-size: 14px;
//           }
//         }

//         /* 桌面端滚动条样式 */
//         @media (min-width: 769px) and (hover: hover) {
//           .swiper-container {
//             position: relative;
//           }

//           .swiper-container:hover .swiper-scrollbar {
//             opacity: 1;
//           }

//           /* 自定义滚动条 */
//           .swiper-scrollbar {
//             opacity: 0;
//             transition: opacity 0.3s;
//             background: #f1f1f1;
//             height: 4px;
//             width: 100%;
//             position: absolute;
//             bottom: 0;
//             left: 0;
//             z-index: 50;
//           }

//           .swiper-scrollbar-drag {
//             background: #888;
//             border-radius: 2px;
//           }
//         }

//         /* 触摸设备优化 */
//         @media (pointer: coarse) {
//           .swiper-slide {
//             touch-action: pan-y;
//           }
//         }

//         /* 减少动画以提升性能 */
//         @media (prefers-reduced-motion: reduce) {
//           * {
//             transition-duration: 0.01ms !important;
//           }
//         }
//       `;
//     }
//   });